import { buildProjectSubcollectionPath, type ProjectScope } from './project-scope';

export const SCHEDULE_SUBCOLLECTION = 'rehearsalSchedule';
export const SCENES_SUBCOLLECTION = 'rehearsalScenes';

export function projectScheduleCollectionPath(scope: ProjectScope): string {
    return buildProjectSubcollectionPath(scope, SCHEDULE_SUBCOLLECTION);
}

export function projectScheduleDocumentPath(scope: ProjectScope, eventId: string): string {
    return `${projectScheduleCollectionPath(scope)}/${eventId}`;
}

export function projectScenesCollectionPath(scope: ProjectScope): string {
    return buildProjectSubcollectionPath(scope, SCENES_SUBCOLLECTION);
}

export function projectSceneDocumentPath(scope: ProjectScope, sceneId: string): string {
    return `${projectScenesCollectionPath(scope)}/${sceneId}`;
}
